import { render, staticRenderFns } from "./WsDeCenterAccredCompsTable.vue?vue&type=template&id=cc2f3c3e"
import script from "./WsDeCenterAccredCompsTable.vue?vue&type=script&lang=js"
export * from "./WsDeCenterAccredCompsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports